<template>
  <div>
     <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form>
        <v-row>
          <h2 class="pb-5">{{ this.parentObject.pageTitle }}</h2>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
          <v-toolbar-title class="subtitle-2">{{$t('statutoryexportcommonused.noparamter')}}</v-toolbar-title>
        </v-container>

        <v-row>
          <div class="pt-5 pl-4">
            <v-btn color="warning" style="width: 100px" @click="backHandler">
              {{$t('button.back')}}
            </v-btn>
          </div>
          <div class="pt-5 pl-4">
            <v-btn color="warning" style="width: 100px" @click="getSOCSOEISExportListHandler">
              {{$t('button.export')}}
            </v-btn>
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-error": ErrorDialog,
    Loading,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
      },
      pageTitle: this.$t('alleissocso.defsocsoandeisexportformat'),

      id: this.parentObject.id,
      data: this.parentObject.data,
      
      titleData: null,
      socsodata: [],
      filler: "",

      totalStfSocsoContAmt: null,
      totalCompnySocsoContAmt: null,
      totalStfSkbbkContAmt: null,
      totalCompnySkbbkContAmt: null,
      totalStfEISContAmt: null,
      totalCompnyEisContAmt: null,

      accErr: [],
      negErrMsg: [],
      salhdErr: [],
      gettotalAmt: [],

      processedCount: null,
      successCount: null,
      errCount: null,

      loading: false,
    
      errMsg: "",
      isErr: false,
      isEdit: this.parentObject.isEdit,
    };
  },

  methods: {

    getSOCSOEISExportListHandler() {
      this.loading = true;
      const vm = this

      let dateHolder2 = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-" + this.daysInMonth(this.data.month, this.data.year);
      let date = moment(dateHolder2).format("YYYY-MM-DD");

      // console.log('date', date)
      // console.log('data', this.data)
      
      this.$store.dispatch('get', {
          url:  `/defaulteissocsoexport/all/${this.$store.getters.userId}`
          + "/" +  this.data.eissocsoexprecid
          + "/" + this.data.eisrefnum + "/" + date + "/" + date
      })
      .then(function (res) {
        vm.loading = false;

       // console.log('data', this.data)

        vm.socsodata = res.data.rec;

        // console.log('res data', vm.socsodata)
        
        vm.exportHandler(); 
      })
      .catch(function (err) {
        vm.errMsg = err;
      });
    },


    async getData() {
      const vm = this
      let body = []
      let staffsocsoamt = []
      let companysocsoamt = []
      let staffskbbkamt = []
      let companyskbbkamt = []
      let staffeisamt = []
      let companyeisamt = []
      let newsocsodetail = []
      let dataholder = vm.socsodata
      let socsodetail = this.filter(dataholder);

      this.processedCount = dataholder.length;
      this.successCount = socsodetail.length;
      this.errCount = dataholder.length - socsodetail.length;
     // let getyear = this.data.year.toString()

      socsodetail.forEach(function (o) {
        var existing = newsocsodetail.filter(function (i) {
          return i.staffcode === o.staffcode;
        })[0];
        if (!existing || existing == undefined) {
          newsocsodetail.push(o);
        } else {
          existing.staffsalary += o.staffsalary;
          existing.staffsocso += o.staffsocso;
          existing.companysocso += o.companysocso;
          existing.staffskbbk += o.staffskbbk;
          existing.companyskbbk += o.companyskbbk;
          existing.staffeis += o.staffeis;
          existing.companyeis += o.companyeis;
        }
      });

      newsocsodetail.forEach(element => {
        // let dateHolder1 = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-" + this.padRJ(1, 2);
        // let dateHolder2 = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-" + this.daysInMonth(this.data.month, this.data.year);
              
        // let date1 = moment(dateHolder1).format("YYYY-MM-DD");
        // let date2 = moment(dateHolder2).format("YYYY-MM-DD"); 

        let monthcontribution;
        // let dateget = ''
        // let emptstatus = ''
      
        //let icnoholder = ''
        let regnoholder = ''
        //if (element.icno != null) icnoholder = element.icno.split("-").join("")
        if (element.regno != null) regnoholder = element.regno.split("-").join("")

        //  if (date1 <= element.hiredate && date2 >= element.hiredate) {
        //   dateget = moment(element.hiredate).format("DDMMYYYY") 
        //   emptstatus = "B";
        //   }
                        
        //   if (date1 <= element.cessadate && date2 >= element.cessadate) { 
        //     dateget = moment(element.cessadate).format("DDMMYYYY");
        //       emptstatus = "H";
        //       }
        monthcontribution = this.padRJ(vm.data.month, 2) + vm.data.year;

        let staffsalaryholder = element.staffsalary.toFixed(2);
        staffsalaryholder = staffsalaryholder.split(".").join("");

        let staffsocsoholder = element.staffsocso.toFixed(2);
        staffsocsoholder = staffsocsoholder.split(".").join("");

        let compnysocsoholder = element.companysocso.toFixed(2);
        compnysocsoholder = compnysocsoholder.split(".").join("");

        let staffskbbkholder = element.staffskbbk.toFixed(2);
        staffskbbkholder = staffskbbkholder.split(".").join("");

        // let compnyskbbkholder = element.companyskbbk.toFixed(2);
        // compnyskbbkholder = compnyskbbkholder.split(".").join("");

        let staffeisholder = element.staffeis.toFixed(2);
        staffeisholder = staffeisholder.split(".").join("");

        let compnyeisholder = element.companyeis.toFixed(2);
        compnyeisholder = compnyeisholder.split(".").join("");
        body.push({
          "Employer Code": this.padSpaceLJ(this.data.eisrefnum, 12),
          "MyCoID/SSM Number": this.padSpaceLJ(regnoholder, 20),
          //"ID Number": this.padSpaceLJ(element.icno ? icnoholder : element.refno.replace(/-/g, ''), 12),
          "ID Number": this.padSpaceLJ(element.refno.replace(/-/g, ''), 12),
          "Employee Name": this.padSpaceLJ(element.psnname, 150),
          "Contribution Month": this.padSpaceRJ(monthcontribution, 6),
          "Employee Salary": this.padSpaceRJ(staffsalaryholder, 14),
          "Contribution Amount SOCSO (Employer)": this.padSpaceRJ(compnysocsoholder, 6),
          "Contribution Amount SOCSO (Employee)": this.padSpaceRJ(staffsocsoholder, 6),
          "Contribution Amount EIS (Employer)": this.padSpaceRJ(compnyeisholder, 6),
          "Contribution Amount EIS (Employee)": this.padSpaceRJ(staffeisholder, 6),
          // "Contribution Amount SKBBK (Employer)": this.padSpaceRJ(compnyskbbkholder, 6),
          "Contribution Amount SKBBK (Employee)": this.padSpaceRJ(staffskbbkholder, 6),
          "Filler 1": this.padSpaceLJ(this.filler, 14),
          "Filler 2": this.padSpaceLJ(this.filler, 20),
        });

        staffsocsoamt.push(element.staffsocso);
        companysocsoamt.push(element.companysocso);
        staffskbbkamt.push(element.staffskbbk);
        companyskbbkamt.push(element.companyskbbk);
        staffeisamt.push(element.staffeis);
        companyeisamt.push(element.companyeis)

      });

      if (staffsocsoamt) {
        let totalStaffSocsoAmtHolder = staffsocsoamt.reduce(function (a, b) {return a + b}, 0);
        this.totalStfSocsoContAmt = totalStaffSocsoAmtHolder.toFixed(2);
      }

       if (companysocsoamt) {
        let totalCompanySocsoAmtHolder = companysocsoamt.reduce(function (a, b) {return a + b}, 0);
        this.totalCompnySocsoContAmt = totalCompanySocsoAmtHolder.toFixed(2);
      }

      if (staffskbbkamt) {
        let totalStaffSkbbkAmtHolder = staffskbbkamt.reduce(function (a, b) {return a + b}, 0);
        this.totalStfSkbbkContAmt = totalStaffSkbbkAmtHolder.toFixed(2);
      }

      if (companyskbbkamt) {
        let totalCompanySkbbkAmtHolder = companyskbbkamt.reduce(function (a, b) {return a + b}, 0);
        this.totalCompnySkbbkContAmt = totalCompanySkbbkAmtHolder.toFixed(2);
      }

       if (staffeisamt) {
        let totalStaffEISAmtHolder = staffeisamt.reduce(function (a, b) {return a + b}, 0);
        this.totalStfEISContAmt = totalStaffEISAmtHolder.toFixed(2);
      }

       if (companyeisamt) {
        let totalCompnyEisAmtHolder = companyeisamt.reduce(function (a, b) {return a + b}, 0);
        this.totalCompnyEisContAmt = totalCompnyEisAmtHolder.toFixed(2);
      }

      this.titleData = this.padRJ(vm.data.month, 2) + "_" + vm.data.year + "_SOCSO & EIS";
   //   console.log('body', body)
      if (this.accErr.length === 0 && body.length > 0) {
        const txtData = this.objectToTxt(body);
        this.download(txtData, this.titleData);
      }
    },

    buildErrorMessage() {
      return this.accErr
        .map((e) => `${e.staffcode} - ${e.psnname}: ${e.errormsg}`)
        .join("; ");
    },

    filter(item) {
      let checkdet = this.detailfilter(item)
      let checkactive = this.activefilter(checkdet)
      let checkpayment = this.paymentfilter(checkactive)
      let checkrequired = this.requiredfieldfilter(checkpayment)
      return checkrequired
    },

    // catches every field the export line-builder dereferences directly (.replace()/.toFixed()),
    // so a null value reports a specific error instead of crashing the whole export silently
    requiredfieldfilter(item) {
      const requiredFields = [
        { field: 'refno', label: this.$t('setuppersonstatutorynumberinfo.refno') },
        { field: 'staffsalary', label: this.$t('alleissocso.empsalary') },
        { field: 'staffsocso', label: this.$t('alleissocso.contamountsocso_employee') },
        { field: 'companysocso', label: this.$t('alleissocso.contamountsocso_employer') },
        { field: 'staffskbbk', label: this.$t('alleissocso.contamountskbbk_employee') },
        { field: 'staffeis', label: this.$t('alleissocso.contamounteis_employee') },
        { field: 'companyeis', label: this.$t('alleissocso.contamounteis_employer') },
      ];

      let data = [];
      item.forEach((e) => {
        let missing = requiredFields
          .filter((f) => e[f.field] === null || e[f.field] === undefined || e[f.field] === '')
          .map((f) => f.label);

        if (missing.length > 0) {
          e.errormsg = this.$t('setupreport_exportmapping.missingrequireddata', { fields: missing.join(', ') });
          this.accErr.push(e);
        } else {
          data.push(e);
        }
      });
      return data;
    },

    detailfilter(item) {
        let dateHolder = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-" 
        + this.daysInMonth(this.data.month, this.data.year);
        let date = moment(dateHolder).format("YYYY-MM-DD");
        let dataitem = item.filter(e => e.refnum == this.data.eisrefnum)
        dataitem = dataitem.filter(e => {
            return moment(e.startdate).format("YYYY-MM-DD") <= date && date <= moment(e.enddate).format("YYYY-MM-DD")
        })
        let noacc = item.filter((e) => !dataitem.includes(e));
        for (let i = 0; i < noacc.length; i++) {
            noacc[i].errormsg = this.$t('setupreport_exportmapping.nodetailinpersonstat');
            this.accErr.push(noacc[i]);
        }
        return dataitem
    },

    activefilter(item) {
      let data = item.filter(e => e.pystatcode == 'ACTIVE')
      let notactive = item.filter((e) => !data.includes(e));
      for (let i = 0; i < notactive.length; i++) {
        notactive[i].errormsg = this.$t('setupreport_exportmapping.paymentisnotactive');
        this.accErr.push(notactive[i]);
      }
      return data
    },

    paymentfilter(item) {
      let data = item.filter(e => {
          return e.staffsocso != 0 || e.companysocso != 0 || e.staffeis != 0 || e.companyeis !=0
          || e.staffskbbk != 0 || e.companyskbbk != 0
      })
      let nopayment = item.filter((e) => !data.includes(e));
      for (let i = 0; i < nopayment.length; i++) {
        nopayment[i].errormsg = this.$t('setupreport_exportmapping.nopayment');
        this.accErr.push(nopayment[i]);
      }
      return data
    },

    objectToTxt(data) {
      const csvRows = [];

      const headers = Object.keys(data[0]);

      //loop over the rows
      for (const row of data) {
        const values = headers.map((header) => {
          const escaped = ("" + row[header]).replace(/"/g, '\\"');
          return `${escaped}`;
        });
        csvRows.push(values.join(""));
      }

      return csvRows.join("\n");
    },

    download(data, title) {
      // const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text" });
      const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", title + ".txt");

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    padRJ(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },

    padLJ(num, size) {
      var s = num + "";
      while (s.length < size) s = s + "0";
      return s;
    },

    padSpaceRJ(char, size) {
      var s = char + "";
      while (s.length < size) s = " " + s;
      return s;
    },

    padSpaceLJ(char, size) {
      var s = char + "";
      while (s.length < size) s = s + " ";
      return s;
    },

    exportHandler() {

        this.accErr = [];
        this.getData();

        if (this.accErr.length > 0) {
          this.isErr = true;
          this.errMsg = this.buildErrorMessage();
          return;
        }

        let item = [];
        item.totalStfSocsoContAmt = this.totalStfSocsoContAmt;
        item.totalCompnySocsoContAmt = this.totalCompnySocsoContAmt;
        item.totalStfSkbbkContAmt = this.totalStfSkbbkContAmt;
        item.totalCompnySkbbkContAmt = this.totalCompnySkbbkContAmt;
        item.totalStfEISContAmt = this.totalStfEISContAmt;
        item.totalCompnyEisContAmt = this.totalCompnyEisContAmt;
        item.accounterr = this.accErr;
        item.successCount = this.successCount;
        item.processedCount = this.processedCount;
        item.errCount = this.errCount;

        if (!this.isErr) {
          this.$router.push({ name: "monthlyeissocsoexportlog", params: { item } });
        }
      
    },

    backHandler() {
      this.$router.push({ name: "monthlyeissocsoexport" });
    },

    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
  },

    mounted() {
    //  this.getAmbankExportListHandler();
    },
};
</script>

<style scoped>
</style>